import { UserService } from '@qv-common/services/auth/user.service';

export const StatusFilter = ['userService', 'biddingUtilsService', 'viewPerspectiveService',
  (userService: UserService, biddingUtilsService, viewPerspectiveService): any => {
  'ngInject';
  return (status): any => biddingUtilsService
    .computeBidStatus(status, userService.user.getValue(), viewPerspectiveService.getViewPerspective());
}];
